import { initializeApp } from 'firebase/app'
import { Capacitor } from '@capacitor/core'

if (!Capacitor.isNativePlatform()) {
  initializeApp({
    apiKey: 'AIzaSyBF7TyxPqqc8I5HKN1hfRP0erT3-itzQ4E',
    authDomain: 'oneshop-push.firebaseapp.com',
    databaseURL: 'https://oneshop-push-default-rtdb.firebaseio.com',
    projectId: 'oneshop-push',
    storageBucket: 'oneshop-push.appspot.com',
    messagingSenderId: '103795536818',
    appId: '1:103795536818:web:721261058020e3319feaab',
    measurementId: 'G-LRWKVZFG8S',
  })
}
